import React, {useState, useEffect} from 'react';
import {CustomInput} from '../../../Components/Input';
import SelectSvgSelector from '../../../Components/InputSelect/SelectSvgSelector';
import {useTranslation} from 'react-i18next';
import {useCheckPasswordMutation} from '../../../redux/userApi';
import {toast} from 'react-toastify';
import s from './UpdatePassword.module.css';
import {handleApiCall} from '../../../assets/utils/utils';

const UpdatePassword: React.FC = () => {
	const [checkPassword] = useCheckPasswordMutation();
	const {t} = useTranslation();

	const [oldPassword, setOldPassword] = useState('');
	const [isOldPasswordValid, setIsOldPasswordValid] = useState(false);
	const [isCheckingPassword, setIsCheckingPassword] = useState(false);
	const [showOldPassword, setShowOldPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);

	// Проверка старого пароля при изменении
	useEffect(() => {
		const checkOldPassword = async () => {
			if (oldPassword.length >= 6) {
				setIsCheckingPassword(true);
				await handleApiCall({
					apiCall: () => checkPassword(oldPassword),
					onSuccess: () => {
						setIsOldPasswordValid(true);
						setIsCheckingPassword(false);
						toast.success(t('Старий пароль вірний'));
					},
					onError: () => {
						setIsOldPasswordValid(false);
						setIsCheckingPassword(false);
					},
				});
			} else {
				setIsOldPasswordValid(false);
			}
		};

		const timeoutId = setTimeout(checkOldPassword, 500);
		return () => clearTimeout(timeoutId);
	}, [oldPassword, checkPassword, t]);

	return (
		<div className={s.password}>
			<div className={s.passwordLabel}>{t('Зміна пароля')}</div>
			<div className={s.passwordTop}>
				<div className={`${s.passwordItem} ${s.itemInfo}`}>
					<div className={s.passwordInputWrapper}>
						<CustomInput
							type={showOldPassword ? 'text' : 'password'}
							autoComplete="one-time-code"
							placeholder={t('Введіть старий пароль')}
							icon={<SelectSvgSelector id={'password'} />}
							value={oldPassword}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
								setOldPassword(e.target.value)
							}
							rightIcon={
								<button
									type="button"
									className={s.eyeButton}
									onClick={() => setShowOldPassword(!showOldPassword)}
									tabIndex={-1}
									aria-label={showOldPassword ? t('Сховати пароль') : t('Показати пароль')}
								>
									<SelectSvgSelector id={showOldPassword ? 'eyeOff' : 'eye'} />
								</button>
							}
						/>
						{isCheckingPassword && (
							<div className={s.checkingIndicator}>
								<div className={s.spinner} />
							</div>
						)}
						{!isCheckingPassword && oldPassword.length >= 6 && (
							<div
								className={`${s.statusIndicator} ${
									isOldPasswordValid ? s.valid : s.invalid
								}`}
							>
								{isOldPasswordValid ? '✓' : '✗'}
							</div>
						)}
					</div>
				</div>
				<div className={`${s.passwordItem} ${s.itemInfo}`}>
					<div className={s.passwordInputWrapper}>
						<CustomInput
							name="new_password"
							type={showNewPassword ? 'text' : 'password'}
							autoComplete="one-time-code"
							placeholder={t('Введіть новий пароль')}
							icon={<SelectSvgSelector id={'password'} />}
							disabled={!isOldPasswordValid}
							rightIcon={
								<button
									type="button"
									className={s.eyeButton}
									onClick={() => setShowNewPassword(!showNewPassword)}
									disabled={!isOldPasswordValid}
									tabIndex={-1}
									aria-label={showNewPassword ? t('Сховати пароль') : t('Показати пароль')}
								>
									<SelectSvgSelector id={showNewPassword ? 'eyeOff' : 'eye'} />
								</button>
							}
						/>
					</div>
					{!isOldPasswordValid && oldPassword.length > 0 && (
						<div className={s.disabledHint}>
							{t('Спочатку підтвердіть старий пароль')}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default UpdatePassword;
